export class StudentScholarshipData {
    studentScholarshipId: number;
    scholarshipId: number;
    studentId: number;
    serviceId: number;
    startDate: Date;
    endDate: Date;
    dirty: boolean;
}

export class UpdateStudentScholarshipData {
    studentScholarshipId: number;
    scholarshipId: number;
    studentId: number;
    serviceId: number;
    startDate: Date;
    endDate: Date;
}

export class DeleteStudentScholarshipData {
    studentScholarshipId: number;
    studentId: number;
}

export class HistoricStudentScholarshipData {
    studentScholarshipId: number;
    studentId: number;
    serviceDescription: string;
    scholarshipDescription: string;
    startDate: Date;
    endDate: Date;
}
